//Product reviews modal callback
if (window.SPRCallbacks) {
  window.SPRCallbacks.onFormSuccess = function(){
    $('[data-reviews-modal-trigger]').trigger('click')
  }
}

function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
      results = regex.exec(location.search);

  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

const getPriceRate = function() {
  return Shopify.currency.active === 'GBP' ? 1.2 : 1;
}

const loadJunipReviews = async function() {
  if (!window.Junip.onsiteEnabled) {
    return;
  }

  const storeKey = window.Junip ? window.Junip.storeKey : null,
        $rating = document.querySelector('.junip-main-product-rating'),
        $reviews = document.querySelector('.junip-product-reviews'),
        $ratings = document.querySelectorAll('.junip-product-rating');

  if (storeKey) {
    let junip = new Junip(storeKey);

    try {
      if (window.Junip.starColor !== '#000000') {
        let style = document.createElement('style');

        style.innerHTML = `
        [class^="spr-icon-"]:before,
        [class*=" spr-icon-"]:before,
        .spr-badge-starrating:before {
          color: ${window.Junip.starColor};
        }
      `;
        document.head.appendChild(style);
      }

      if ($rating) {
        let id = $rating.dataset.productId;

        await junip.loadProduct(id);
      }

      if ($reviews) {
        let ids = $reviews.dataset.productBundle ? $reviews.dataset.productBundle : $reviews.dataset.productId,
            reviewsCount = $reviews.dataset.reviewsCount;

        if (!reviewsCount) {
          reviewsCount = 5;
        }

        junip.loadCallbacks($reviews);
        await junip.loadAllProductReviews(ids);
        $reviews.innerHTML = junip.createBaseHtml();
        $reviews.classList.add('loaded');
        junip.setReviewsPerPage(reviewsCount);
        junip.printPage(1);
        junip.addEventListeners();
        junip.onLoad();
      }

      if ($rating) {
        junip.printProductRating();
      }

      if ($ratings.length) {
        let ids = '';
        $ratings.forEach(function ($rating) {
          ids += `${$rating.dataset.productId},`;
          $rating.classList.add('loaded');
        })
        ids.slice(0, -1);
        await junip.loadProducts(ids);
        junip.printProductsRating();
      }
    } catch (e) {
      console.log(e);

      if ($reviews) {
        $reviews.classList.add('loaded');
      }
    }
  }
};

const loadJunipAjaxReviews = async function() {
  if (!window.Junip.onsiteEnabled) {
    return;
  }

  const storeKey = window.Junip ? window.Junip.storeKey : null,
      $ratings = document.querySelectorAll('.junip-product-rating:not(.loaded)');

  if (storeKey) {
    let junip = new Junip(storeKey);

    try {
      if ($ratings.length) {
        let ids = '';

        $ratings.forEach(function ($rating) {
          ids += `${$rating.dataset.productId},`;
          $rating.classList.add('loaded');
        })
        ids.slice(0, -1);
        await junip.loadProducts(ids);
        junip.printProductsRating();
      }
    } catch (e) {
      console.log(e);
    }
  }
};

const handleAjaxCart = function (e) {
  e.preventDefault()
  /* Send to shopify cart */
  let clickedElement = e.target || e.srcElement,
      variantId = parseInt(clickedElement.dataset.variantId),
      quantity = parseInt(clickedElement.dataset.quantity),
      price = clickedElement.dataset.price,
      sampleProductAdded = false,
      upsellInCart = localStorage.getItem('upsellInCart') ? JSON.parse(localStorage.getItem('upsellInCart')) : [],
      itemsToAdd = [],
      item;

  if (isNaN(variantId) || clickedElement.hasAttribute('data-back-in-stock')) {
    return;
  }

  if ((variantId === window.sampleProduct.id || window.buyXgetY.xIDsForbid.includes(variantId)) && isYInCart()) {
    alert(`Please remove ${window.buyXgetY.yTitle} from the cart`);
    return;
  }

  // Check if upsell already exist in cart
  if (window.upsell.isActive) {
    let isClickedProductUpsell = window.upsell.products.find(function(product) {
      return product.id === variantId;
    });

    if (isClickedProductUpsell && (upsellInCart.includes(variantId) || upsellInCart.length >= window.upsell.limit)) {
      alert(`Please remove sample from the cart`);
      clickedElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: variantId,
          quantity: quantity
        }
      }));

      return;
    }
  }

  item = {
    id: parseInt(variantId),
    quantity: parseInt(quantity),
    price: parseInt(price)
  };
  itemsToAdd.push(item);

  // Check if GWP is already in the cart
  if (typeof window.sampleProduct !== 'undefined') {
    if (!window.sampleProduct.inCart && window.sampleProduct.isActive && window.sampleProduct.id !== 0) {
      sampleProductAdded = true;
      itemsToAdd.push({
        id: window.sampleProduct.id,
        quantity: 1
      });
    }
  }

  // Check if Buy X get Y is active
  if (!window.buyXgetY.yHasInfiniteVariants) {
    itemsToAdd = addBuyXGetY(itemsToAdd);
  }

  document.dispatchEvent(new CustomEvent('theme:loading:start'));
  $.post(window.routes.cartAddUrl + '.js',{
    formType: "product",
    utf8: "✓",
    items: itemsToAdd
  }, function (result, status) {
    if (status === "success") {
      // Check if product is added right now
      if (sampleProductAdded) {
        window.sampleProduct.inCart = true;
      }

      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      clickedElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: variantId,
          quantity: quantity
        }
      }));

      if (window.buyXgetY.yHasInfiniteVariants || window.buyXgetY.yAfterPopupShow) {
        checkAddBuyXGetYPopup();
      }
    } else {
      // WE REACHED OUR TARGET SERVER, BUT IT RETURNED AN ERROR
      console.error('KVALIFIK: ERROR: COULD NOT ADD PRODUCT TO CART ASYNC');
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }
  }, 'json');
};

const checkCartMinimum = function(e) {
  var totalCartPrice = function() {
    var price = 0;
    getCartItems().forEach(function(cartItem) {
      price += (cartItem.price * cartItem.quantity);
    });
    return price;
  }

  if (totalCartPrice() < window.minCartAmount) {
    e.preventDefault();
  }
};

const setAccordionBackground = function() {
  let $container = document.querySelector('.Product__Container2');
  let $button = $container.querySelector('button[aria-expanded="true"]');
  let bgImage = $button?.getAttribute('data-toggle-bg-image');
  let bgMobileImage = $button?.getAttribute('data-toggle-bg-mobile-image');
  let isMobile = window.innerWidth < 1008;

  if (isMobile) {
    if (null !== bgMobileImage && bgMobileImage.length) {
      $container.style.backgroundImage = `url(${bgMobileImage})`;
    }
  } else {
    if (null !== bgImage && bgImage.length) {
      $container.style.backgroundImage = `url(${bgImage})`;
    }
  }
}

const toggleContent = function() {
  let expandedToggleButtons = document.querySelectorAll(`[data-toggle-group=${this.dataset.toggleGroup}][aria-expanded="true"]`);
  let offset = 0;
  let _this = this;
  let section = this.closest('section');

  expandedToggleButtons.forEach(function(toggleButton) {
    if (toggleButton !== _this) {
      hide(toggleButton);
    }
  });

  if (this.getAttribute('aria-expanded') === 'false') {
    show(this);

    if (window.innerWidth < 1008) {
      setTimeout(function () {
        offset = section.offsetTop + _this.offsetTop;

        if (window.scrollY > offset) {
          window.scrollTo({
            top: offset,
            behavior: 'smooth'
          });
        }
      }, 500);
    }
  } else {
    hide(this);
  }

  function hide($button) {
    let $contents = document.querySelectorAll($button.dataset.toggleTarget);
    let $container = $button.closest('.Container').parentElement;
    let bgColor = $button.getAttribute('data-toggle-bg-color');
    let bgImage = $button.getAttribute('data-toggle-bg-image');
    let bgMobileImage = $button.getAttribute('data-toggle-bg-mobile-image');
    let textColor = $button.getAttribute('data-toggle-text-color');
    let isMobile = window.innerWidth < 1008;

    $button.setAttribute('aria-expanded', 'false');

    $container.style.background = 'none';
    $container.style.color = 'unset';

    /*if (isMobile) {
      if (null !== bgMobileImage && bgMobileImage.length) {
        $container.style.backgroundImage = `url(${bgMobileImage})`;
      }
    } else {
      if (null !== bgImage && bgImage.length) {
        $container.style.backgroundImage = `url(${bgImage})`;
      }
    }

    if (null !== bgColor && bgColor.length) {
      $container.style.backgroundColor = bgColor;
    }
    if (null !== textColor && textColor.length) {
      $container.style.color = textColor;
    }*/

    $contents.forEach(function($content) {
      $content.classList.remove('expanded');
      $content.style.removeProperty('transition');
      $content.style.height = `${$content.scrollHeight}px`;
      setTimeout(function () {
        $content.style.height = '0';
      }, 1);
      setTimeout(function () {
        $content.style.visibility = 'hidden';
        if ($content.dataset.collapseWidth) {
          $content.style.display = 'none';
        }
      }, 400);
    });
  }

  function show($button) {
    let $contents = document.querySelectorAll($button.dataset.toggleTarget);
    let $container = $button.closest('.Container').parentElement;
    let bgColor = $button.getAttribute('data-toggle-bg-color');
    let bgImage = $button.getAttribute('data-toggle-bg-image');
    let bgMobileImage = $button.getAttribute('data-toggle-bg-mobile-image');
    let textColor = $button.getAttribute('data-toggle-text-color');
    let isMobile = window.innerWidth < 1008;

    if ($button.dataset.collapseWidth) {
      $contents.style.display = "block";
    }

    if (isMobile) {
      if (null !== bgMobileImage && bgMobileImage.length) {
        $container.style.backgroundImage = `url(${bgMobileImage})`;
      }
    } else {
      if (null !== bgImage && bgImage.length) {
        $container.style.backgroundImage = `url(${bgImage})`;
      }
    }

    if (null !== bgColor && bgColor.length) {
      $container.style.backgroundColor = bgColor;
    }
    if (null !== textColor && textColor.length) {
      $container.style.color = textColor;
    }

    $button.setAttribute('aria-expanded', 'true');

    $contents.forEach(function($content) {
      $content.style.transition = 'height 0.35s ease-in-out';
      $content.style.height = `${$content.scrollHeight}px`;
      $content.style.visibility = 'visible';

      if ($content.dataset.collapseWidth) {
        setTimeout(function() {
          $content.style.display = 'block';
        }, 380);
      }

      setTimeout(function() {
        $content.style.height = 'auto';
        $content.classList.add('expanded');
      }, 400);
    });
  }
}

const infiniteOptionUpdate = function (type) {
  var $parent = document.querySelector((type === 'product') ? '#infiniteoptions-container' : '#gwp-picker-modal'),
    $infiniteOptions = $parent.querySelector('.infinite-options'),
    $notCheckedInputs = $infiniteOptions.querySelectorAll('label input:not(:checked):not([data-unavailable])'),
    $checkedInputs = $infiniteOptions.querySelectorAll('label input:checked:not([data-unavailable])'),
    $variantTitles = $infiniteOptions.querySelector('input[name="properties[Selected samples]"]'),
    $variantIds = $infiniteOptions.querySelector('input[name="infinite_options_ids"]'),
    windowInfiniteOptions = (type === 'product') ? window.infiniteOptions : window.yInfiniteOptions,
    disabled = '';

  $infiniteOptions.classList.remove('warning');
  $variantTitles.value = '';
  $variantIds.value = '';

  // Check max limit
  if ($checkedInputs.length >= windowInfiniteOptions.maxSelections) {
    disabled = 'disabled';
  }

  $notCheckedInputs.forEach(function($input) {
    $input.disabled = disabled;
  });

  // Add checked
  $checkedInputs.forEach(function($input, index, array) {
    let $label = $input.parentNode;

    $variantTitles.value += $label.textContent;
    $variantIds.value += $input.value;

    if (index < array.length - 1) {
      $variantTitles.value += ',';
      $variantIds.value += ',';
    }
  });
};

const infiniteOptionUpdateProduct = function() {
  infiniteOptionUpdate('product');
};

const infiniteOptionUpdateGWP = function() {
  infiniteOptionUpdate('gwp');
};

const showPopup = function(e, callback = function() {}) {
  let $modal,
      delay,
      image,
      isLoaded = false,
      execCounter = 0;

  if (e.currentTarget) {
    e.preventDefault();
    $modal = document.querySelector(e.currentTarget.dataset.popupTarget);
  } else {
    $modal = document.querySelector(e);
  }

  if (!$modal) {
    return;
  }

  delay = $modal.hasAttribute('data-delay') ? $modal.getAttribute('data-delay') : 0;
  image = $modal.querySelector('img');

  if (image) {
    lazySizes.loader.unveil(image);

    if (image.complete && image.naturalHeight !== 0) {
      isLoaded = true;
    }

    image.onload = function () {
      isLoaded = true;
    }
  } else {
    isLoaded = true;
  }

  const exec = function() {
    let $modalWrapper = $modal.querySelector('.popup-wrapper');

    execCounter++;

    if ($modalWrapper) {
      let modalsShown = document.querySelectorAll('.popup-modal.show .popup-wrapper.show').length,
          zIndex = parseInt(window.getComputedStyle($modal).zIndex);

      zIndex += modalsShown;
      $modal.style.zIndex = zIndex.toString();
      $modal.classList.add('show');
      document.body.classList.add('no-overflow');
      setTimeout(function () {
        if (isLoaded) {
          $modalWrapper.classList.add('show');
        } else if (execCounter < 20) {
          setTimeout(exec, 250);
        }
      }, 10);

      callback();
    }
  }

  setTimeout(exec, delay);
};

const closePopup = function(e) {
  let clickedElement = e.target || e.srcElement;
  let clickedElementClass = clickedElement.className;

  if ((clickedElementClass.includes('popup-modal') && clickedElementClass.includes('show')) || clickedElement.className.includes('popup__Close')) {
    let $popup = document.querySelector('.popup-modal.show');
    let $popupWrapper = document.querySelector('.popup-wrapper.show');

    if (typeof $popup !== 'undefined' && typeof $popupWrapper !== 'undefined') {
      $popup.classList.remove('show');
      $popupWrapper.classList.remove('show');
    }

    if (clickedElementClass.includes('region-selector-modal') || clickedElement.closest('.popup-modal').className.includes('region-selector-modal')) {
      e.preventDefault();
      Cookies.set("isGeoRedirected", "true");
    }

    document.body.classList.remove('no-overflow');
  }
};

const hidePopup = function(e) {
  let $parent = e.target.closest('[aria-hidden="false"]');
  $parent?.setAttribute('aria-hidden', true);
};

const initRegularPopup = function() {
  let isShown = getItemWithExpiry('regular_popup');

  if (!isShown) {
    showPopup('#regular-modal', function() {
      setItemWithExpiry('regular_popup', 1, 20160);
    });
  }
};

const showSubscriptionPopup = function (noDelay = false) {
  let $popup = document.querySelector('#subscription-modal');

  if ($popup) {
    let popupDelay = parseInt($popup.getAttribute('data-delay')),
        image = $popup.querySelector('img'),
        isLoaded = false;

    if (noDelay) {
      popupDelay = 500;
    }

    lazySizes.loader.unveil(image);

    image.onload = function() {
      isLoaded = true;
    }

    setTimeout(function () {
      if (document.activeElement.localName !== 'input' && isLoaded) {
        $popup.setAttribute('aria-hidden', 'false');
      } else {
        showSubscriptionPopup(true);
      }
    }, popupDelay);
  }
};

const checkAddBuyXGetYPopup = function(hideModal = false) {
  setTimeout(function() {
    if (!isYInCart() && !isForbiddenInCart() && !hideModal && typeof window.buyXgetY !== 'undefined' && window.buyXgetY.isActive && window.buyXgetY.yID) {
      let popup = window.buyXgetY.yAfterPopupShow ? '#buyxgety-modal' : '#gwp-picker-modal',
          cartItems = getCartItems();

      if ((window.buyXgetY.condition === 'min_quantity' && buyXGetYHasMinimumQuantity(cartItems)) ||
          (window.buyXgetY.condition === 'min_amount' && buyXGetYHasMinimumPrice(cartItems))) {
        showPopup(popup);
      }
    }
  }, 1000);
}

const hideAnnouncementBar = function() {
  let $announcement = document.querySelector('#shopify-section-announcement');
  let $stickyHeader = document.querySelector('#shopify-section-header.sticky');
  let announcementHeight = $announcement.clientHeight;

  sessionStorage.setItem('announcementBarHide', 'true');
  $announcement.style.transform = 'translateY(-100%)';
  $announcement.style.marginBottom = `-${announcementHeight}px`;
  $announcement.classList.add('collapsing');

  if (null !== $stickyHeader) {
    $stickyHeader.style.top = '0';
  }

  setTimeout(function() {
    $announcement.classList.remove('collapsing');
    $announcement.remove();
  }, 500);
}

let lastScrollPosY = document.body.scrollTop || document.documentElement.scrollTop;

const stickyBarInit = function() {
  let $stickyAnnouncement = document.querySelector('#shopify-section-announcement.sticky');
  let $stickyHeader = document.querySelector('#shopify-section-header.sticky');

  if (null !== $stickyHeader) {
    $stickyHeader.classList.add('show');

    if (null !== $stickyAnnouncement) {
      $stickyHeader.style.top = `${$stickyAnnouncement.clientHeight-1}px`;
    }
  }
}

const applyDiscount = async function(discount) {
  let response = await fetch(window.routes.discountUrl + '/' + discount, {
    method: 'GET'
  });

  if (response.status !== 200) {
    console.error(response);
    return response;
  }

  return response;
}

stickyBarInit();

const stickyBarScroll = function() {
  let scrollPosY = document.body.scrollTop || document.documentElement.scrollTop;
  let $stickyAnnouncement = document.querySelector('#shopify-section-announcement.sticky');
  let $stickyHeader = document.querySelector('#shopify-section-header.sticky');
  let $stickyArticleToolbar = document.querySelector('.ArticleToolbar');

  if (null !== $stickyHeader) {
    if (scrollPosY < lastScrollPosY) {
      showStickyHeader();
    } else if (scrollPosY > lastScrollPosY && scrollPosY > window.stickyHeaderScrollOffset) {
      hideStickyHeader();
    }
  }

  if (null !== $stickyAnnouncement && !$stickyAnnouncement.classList.contains('collapsing')) {
    if (scrollPosY < lastScrollPosY) {
      showStickyAnnouncement();
    } else if (scrollPosY > lastScrollPosY && scrollPosY > window.stickyAnnouncementScrollOffset) {
      hideStickyAnnouncement();
    }
  }

  if (null !== $stickyArticleToolbar) {
    repositionStickyArticleToolbar();
  }

  lastScrollPosY = scrollPosY;

  function showStickyAnnouncement() {
    $stickyAnnouncement.style.transform = 'translateY(0)';

    if (null !== $stickyHeader) {
      $stickyHeader.style.top = `${$stickyAnnouncement.clientHeight - 1}px`;
      $stickyHeader.classList.add('show');
    }
  }

  function hideStickyAnnouncement() {
    $stickyAnnouncement.style.transform = `translateY(-100%)`;

    if (null !== $stickyHeader) {
      $stickyHeader.style.top = '0';
      $stickyHeader.classList.add('show');
    }
  }

  function showStickyHeader() {
    if (null !== $stickyAnnouncement && $stickyAnnouncement.classList.contains('collapsing')) {
      return;
    }
    $stickyHeader.style.transform = 'translateY(0)';
    $stickyHeader.classList.add('show');
  }

  function hideStickyHeader() {
    $stickyHeader.style.transform = 'translateY(-100%)';
    $stickyHeader.classList.remove('show');
  }

  function repositionStickyArticleToolbar() {
    let offsetTop = $stickyHeader.clientHeight - 2;
    if ($stickyHeader.style.transform === 'translateY(-100%)') {
      offsetTop = 0;
    }
    if ($stickyAnnouncement.style.transform !== 'translateY(-100%)') {
      offsetTop += $stickyAnnouncement.clientHeight;
    }
    $stickyArticleToolbar.style.top = `${offsetTop}px`;
  }
}

stickyBarScroll();

const stickyProductHeaderScroll = function() {
  let $stickyAnnouncement = document.querySelector('#shopify-section-announcement.sticky');
  let $stickyHeader = document.querySelector('#shopify-section-header.sticky');
  let $productStickyHeader = document.getElementById('ProductStickyHeader');
  let $actualProductButton = document.querySelector('.Product__Info .ProductForm__AddToCart');
  let actualProductButtonOffset = 0;
  let $scrollToTopButton = document.getElementById('go-to-top-button');

  if ($actualProductButton) {
    actualProductButtonOffset = $actualProductButton.offsetTop + 100;
  }

  if (document.body.scrollTop > actualProductButtonOffset || document.documentElement.scrollTop > actualProductButtonOffset) {
    $productStickyHeader.classList.add("active");
    $scrollToTopButton.style.transform = `translateY(-${$productStickyHeader.offsetHeight - 20}px)`;
  } else {
    $productStickyHeader.classList.remove("active");
    $scrollToTopButton.style.transform = 'none';
  }
  // a small offset is needed to close a gap
  let offset = -2;

  if (null !== $stickyHeader) {
    let hasShowClass = $stickyHeader.classList.contains('show');
    let isTransformed = $stickyHeader.style.transform.replace(/[^0-9-]+/g,"").includes('-100');

    if (hasShowClass && !isTransformed) {
      offset += $stickyHeader.clientHeight;
    }
  }

  if (null !== $stickyAnnouncement) {
    let hasCollapsingClass = $stickyAnnouncement.classList.contains('collapsing');
    let isTransformed = $stickyAnnouncement.style.transform.replace(/[^0-9-]+/g,"").includes('-100');

    if (!hasCollapsingClass && !isTransformed) {
      offset += $stickyAnnouncement.clientHeight;
    }
  }

  $productStickyHeader.style.top = offset + "px";
}

const freeSampleNoticeScroll = function(e) {
  e.preventDefault();
  let $drawer = document.querySelector('#sidebar-cart .Drawer__Main')
  $drawer.scrollTo({
    top: ($drawer.clientHeight),
    behavior: 'smooth'
  });
}

const setFreeSamplesNoticeOffsetTop = function() {
  let $shippingNotice = document.querySelector('.Cart__ShippingNotice');
  let $freeSampleNotice = document.querySelector('.Cart__FreeSamplesNotice');

  $freeSampleNotice.style.top = `${$shippingNotice.clientHeight + .5}px`;
}

const alignProductTitles = function() {
  if ($(window).width() < 1007) {
    var $products = $('.ProductItem__Info');
    for (var i = 0; i <= $products.length - 2; i = i + 2) {
      if ($products[i].offsetHeight !== $products[i+1].offsetHeight) {
        var diff = Math.abs($products[i].offsetHeight - $products[i + 1].offsetHeight) + 4; // 4 is default margin-top
        var j = i;
        if ($products[i].offsetHeight > $products[i+1].offsetHeight) {
          j = i + 1;
        }
        $($products[j]).find('.ProductItem__PriceList').css('margin-top', diff);
      }
    }
  }
};

const setItemWithExpiry = function (key, value, ttl) {
  const now = new Date()

  // `item` is an object which contains the original value
  // as well as the time (in minutes) when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + (ttl * 60000),
  }
  localStorage.setItem(key, JSON.stringify(item))
};

const getItemWithExpiry = function (key) {
  const itemStr = localStorage.getItem(key)

  if (!itemStr) {
    return null
  }

  const item = JSON.parse(itemStr)
  const now = new Date()

  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key)
    return null
  }

  return item.value
};

const handleMultipleAjaxCart = function (ids) {
  let items = [],
    sampleProductAdded = false;

  ids.forEach(function (id) {
    if (id) {
      items.push({
        id: parseInt(id),
        quantity: 1
      });
    }
  })

  // Check if GWP is already in the cart
  if (typeof window.sampleProduct !== 'undefined') {
    if (!window.sampleProduct.inCart && window.sampleProduct.isActive) {
      sampleProductAdded = true;
      items.push({
        id: window.sampleProduct.id,
        quantity: 1
      });
    }
  }

  // Check if Buy X get Y is active
  if (!window.buyXgetY.yHasInfiniteVariants) {
    items = addBuyXGetY(items);
  }

  $.post(window.routes.cartAddUrl + '.js', {
    formType: "product",
    utf8: "✓",
    items: items
  }, function (result, status) {
    if (status === "success") {
      if (sampleProductAdded) {
        window.sampleProduct.inCart = true;
      }

      var clickedElement = document.querySelector('[data-quiz-add-regular]');

      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (clickedElement) {
        clickedElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: items[0],
            quantity: 1
          }
        }));
      }

      if (window.buyXgetY.yHasInfiniteVariants || window.buyXgetY.yAfterPopupShow) {
        checkAddBuyXGetYPopup();
      } else if (!clickedElement) {
        window.location.href = '/cart';
      }
    } else {
      console.log('Error adding products to cart');
    }
  }, 'json');
};

const checkInfiniteOptionsMinimumSelections = function (e) {
  e.preventDefault();
  var selected = document.querySelectorAll('.infinite-options input[type=checkbox]:checked').length;

  if (selected < window.infiniteOptions['freshly-picked-samples'].minSelections) {
    e.preventDefault();
    alert('Please select your options before adding this item to cart');
  }
};

const addItemsToWindowCart = function (items) {
  if (typeof window.cart === 'undefined') {
    return;
  }

  items.forEach(function (item) {
    var found = false;
    window.cart.forEach(function (cartItem) {
      if (item.id === cartItem.id) {
        cartItem.quantity += item.quantity;
        found = true;
      }
    });
    if (!found) {
      window.cart.push(item);
    }
  });
};

const updateItemInWindowCart = function (item) {
  if (typeof window.cart === 'undefined') {
    return;
  }

  window.cart.forEach(function (cartItem, index, object) {
    if (item.id === cartItem.id) {
      if (item.quantity === 0) {
        object.splice(index, 1);
      } else {
        cartItem.quantity = item.quantity;
      }
    }
  });
};

const isYInCart = function() {
  return null !== document.querySelector('[data-is-gwp]');
}

const isFreeSampleInCart = function() {
  return null !== document.querySelector('[data-is-sample]');
}

const isForbiddenInCart = function() {
  let $cartItems = document.querySelectorAll('.CartItem');
  let isForbidden = false;

  for (let i = 0; i < $cartItems.length; i++) {
    let id = parseInt($cartItems[i].getAttribute('data-variant-id'));
    if (window.buyXgetY.xIDsForbid.includes(id)) {
      isForbidden = true;
      break;
    }
  }

  return isForbidden;
}

const getCartItems = function() {
  let line_items = window.location.pathname === '/cart' ? document.querySelectorAll('#main .CartItem > .CartItem__Actions input[data-line-id]') : document.querySelectorAll('#sidebar-cart input[data-line-id]');
  let items = [];

  line_items.forEach(function(line_item) {
    items.push({
      id: parseInt(line_item.getAttribute('data-line-id').split(':')[0]),
      price: parseFloat(line_item.getAttribute('data-price')),
      quantity: parseInt(line_item.value)
    });
  });

  return items;
}

const includesObjectProperty = function(array, property, value) {
  let index = false;
  array.forEach(function(item, i) {
    if (item[property] === value) {
      index = i;
    }
  });
  return index;
}

const checkRemoveYBuyXGetY = function(responseCartItems = []) {
  if (typeof window.buyXgetY !== 'undefined') {
    if (isYInCart() && window.buyXgetY.isActive && window.buyXgetY.yID) {
      let cartItems = responseCartItems.length ? responseCartItems : getCartItems(),
          getYNodes = document.querySelectorAll('.CartItem__Remove[data-line-id^="'+window.buyXgetY.yID+'"]'),
          priceRate = getPriceRate();

      if (window.buyXgetY.condition === 'min_quantity') {
        let totalQuantityX = 0;
        // Calculate total quantity of xIDs in cart
        cartItems.forEach(function (item) {
          if (window.buyXgetY.xIDs.includes(item.id) && item.id !== window.buyXgetY.yID) {
            totalQuantityX += item.quantity;
          }
        });

        /*
        Disable here
        */
        if (totalQuantityX < window.buyXgetY.conditionAmount && getYNodes.length) {
          getYNodes[getYNodes.length-1].click();
        }
      } else if (window.buyXgetY.condition === 'min_amount') {
        let totalPriceX = 0;
        cartItems.forEach(function (item) {
          if (window.buyXgetY.xIDs.includes(item.id) && item.id !== window.buyXgetY.yID) {
            totalPriceX += item.price * item.quantity;
          }
        });

        totalPriceX *= priceRate;

        /*
        Disable here
         */
        if (totalPriceX < window.buyXgetY.conditionAmount && getYNodes.length) {
          getYNodes[getYNodes.length-1].click();
        }
      }
    }
  }
}

const recreateUpsellUnlockContainer = function() {
  let headingHtml = ``;
  let upsellHtml = ``;
  let html = ``;
  const isCartPage = !!document.querySelector('body.template-cart');
  let $container;
  let $cartItems;
  const upsellUnlockProducts = window.upsellUnlock.products;
  let upsellUnlockLeftCounter = window.upsellUnlock.limit;
  const upsellUnlockInCart = [];
  const upsellUnlockActive = window.upsellUnlock.isActive;
  const cart_total_price = document.querySelector('[data-cart-total-price]') ? parseInt(document.querySelector('[data-cart-total-price]').dataset.cartTotalPrice) : 0;

  if (!upsellUnlockActive || upsellUnlockProducts.length === 0) {
    return;
  }

  if (isCartPage) {
    $container = document.querySelector('.Cart__ItemList.upsell-unlock');
    $cartItems = document.querySelectorAll('.Cart__ItemList:not(.upsell-unlock) .CartItem');
  } else {
    $container = document.querySelector('.Drawer__Container.samples.upsell-unlock');
    $cartItems = document.querySelectorAll('.Drawer__Main .CartItem');
  }

  upsellUnlockProducts.forEach(function(product) {
    $cartItems.forEach(function ($item) {
      if (product.id === parseInt($item.dataset.variantId)) {
        upsellUnlockInCart.push(product.id);
        upsellUnlockLeftCounter--;
      }
    });
  });

  headingHtml = window.upsellUnlock.heading;

  for (let i = 0; i < upsellUnlockProducts.length; i++) {
    const product = upsellUnlockProducts[i];
    const purchase_minimum = product.purchase_minimum;

    if (cart_total_price < purchase_minimum) {
      const purchaseLeftTillNext = (purchase_minimum - cart_total_price) / 100;
      product.leftToAdd = window.upsellUnlock.headingUnlockProduct.replace('(amount)', purchaseLeftTillNext).replace('(product)', product.title);
    } else {
      product.leftToAdd = '';
    }

    upsellHtml += `
    <div class="CartItem__Upsell" data-variant-id="${product.id}" data-title="${product.title}">
      <div class="CartItem__ImageWrapper AspectRatio">
        <div class="AspectRatio" style="--aspect-ratio: 1.0">
          <img class="CartItem__Image Image--fadeIn lazyautosizes Image--lazyLoad"
               alt="${product.title}"
               width="50"
               height="50"
               data-sizes="auto"
               data-srcset="${product.featured_image}"
            />
        </div>
      </div>

      <div class="CartItem__Info">
        <h2 class="CartItem__Title Heading">
          <a href="${product.url}">
            ${product.title}
          </a>
        </h2>

        <div class="CartItem__NewPrice Heading Text--subdued">${product.discount_text}</div>
        ${product.leftToAdd ? `<div class="CartItem__Meta Heading Text--subdued">${product.leftToAdd}</div>` : ''}
      </div>
      <div class="CartItem__Actions">
        <button class="Button Button--primary Button--small kvalifik-ajax"
                aria-label="Add to cart"
                data-variant-id="${product.id}"
                data-quantity="1"
                ${upsellUnlockLeftCounter <= 0 || cart_total_price < purchase_minimum ? 'disabled' : ''}>
          Add
        </button>
      </div>
    </div>
    `;
  }

  localStorage.setItem('upsellUnlockInCart', JSON.stringify(upsellUnlockInCart));

  if (isCartPage) {
    html = `
      <div class="Cart__ItemHeading Heading Text--subdued u-h7">
        ${headingHtml}
      </div>
      ${upsellHtml}
    `;
  }
  else {
    html = `
      <div class="Drawer__Title Heading u-h7">
        ${headingHtml}
      </div>
      <div class="Cart__ItemList">
        ${upsellHtml}
      </div>
    `;
  }

  $container.innerHTML = html;

  if (document.querySelector('.Cart__ShippingNotice') && document.querySelector('.Cart__FreeSamplesNotice')) {
    setFreeSamplesNoticeOffsetTop();
  }
}

const recreateUpsellContainer = function() {
  let headingHtml = ``;
  let upsellHtml = ``;
  let html = ``;
  let isCartPage = !!document.querySelector('body.template-cart');
  let $container;
  let $cartItems;
  let upsellProducts = window.upsell.products;
  let upsellLeftCounter = window.upsell.limit;
  let upsellInCart = [];
  let upsellActive = window.upsell.isActive;

  if (!upsellActive || upsellProducts.length === 0) {
    return;
  }

  if (isCartPage) {
    $container = document.querySelector('.Cart__ItemList.upsell');
    $cartItems = document.querySelectorAll('.Cart__ItemList:not(.upsell) .CartItem');
  } else {
    $container = document.querySelector('.Drawer__Container.samples.upsell');
    $cartItems = document.querySelectorAll('.Drawer__Main .CartItem');
  }

  upsellProducts.forEach(function(product) {
    let skip = false;

    $cartItems.forEach(function ($item) {
      if (product.id === parseInt($item.dataset.variantId)) {
        upsellInCart.push(product.id);
        upsellLeftCounter--;
      }
    });
  });

  upsellProducts.forEach(function(product) {
    if (upsellInCart.includes(product.id)) {
      return;
    }

    upsellHtml += `
    <div class="CartItem__Upsell" data-variant-id="${product.id}" data-title="${product.title}">
      <div class="CartItem__ImageWrapper AspectRatio">
        <div class="AspectRatio" style="--aspect-ratio: 1.0">
          <img class="CartItem__Image Image--fadeIn lazyautosizes Image--lazyLoad"
               alt="${product.title}"
               width="50"
               height="50"
               data-sizes="auto"
               data-srcset="${product.featured_image}"
            />
        </div>
      </div>

      <div class="CartItem__Info">
        <h2 class="CartItem__Title Heading">
          <a href="${product.url}">
            ${product.title}
          </a>
        </h2>

        <div class="CartItem__Meta Heading Text--subdued">${product.price}</div>
      </div>
      <div class="CartItem__Actions">
        <button class="Button Button--primary Button--small kvalifik-ajax"
                aria-label="Add to cart"
                data-variant-id="${product.id}"
                data-quantity="1"
                ${upsellLeftCounter <= 0 ? 'disabled' : ''}>
          Add
        </button>
      </div>
    </div>
    `;
  });

  localStorage.setItem('upsellInCart', JSON.stringify(upsellInCart));

  if (upsellLeftCounter > 0) {
    let upsellHeadingPlural = upsellLeftCounter > 1 ? 's' : '';
    headingHtml = window.upsell.heading.replace('(count)', upsellLeftCounter).replace('(s)', upsellHeadingPlural);
  } else {
    headingHtml = window.upsell.headingLimitReach;
  }

  if (isCartPage) {
    html = `
      <div class="Cart__ItemHeading Heading Text--subdued u-h7">
        ${headingHtml}
      </div>
      ${upsellHtml}
    `;
  }
  else {
    html = `
      <div class="Drawer__Title Heading u-h7">
        ${headingHtml}
      </div>
      <div class="Cart__ItemList">
        ${upsellHtml}
      </div>
    `;
  }

  $container.innerHTML = html;

  if (document.querySelector('.Cart__ShippingNotice') && document.querySelector('.Cart__FreeSamplesNotice')) {
    setFreeSamplesNoticeOffsetTop();
  }
}

/**
 * Deprecated. Use if upsell has infinite-options
 */
const addUpsellToCart = function(e) {
  e.preventDefault()
  let $upsellSample = e.target.closest('.CartItem__Upsell');
  let variantId = parseInt($upsellSample.dataset.variantId);
  let $parentProduct = document.querySelector(`.CartItem[data-variant-id="${window.upsellProduct.id}"]`);
  let parentProductKey = $parentProduct ? $parentProduct.dataset.variantKey : null;
  let parentInCart = !!$parentProduct;
  let parentProduct = {
    id: parentProductKey ? parentProductKey : window.upsellProduct.id,
    quantity: 1,
    properties: {
      "Selected samples": samples,
      _io_order_group: window.upsellProduct.id.toString()
    }
  };
  let productsForCart = [{
    id: variantId,
    quantity: 1,
    properties: {
      _io_parent_order_group: window.upsellProduct.id
    }
  }];

  if (!parentInCart) {
    productsForCart.push(parentProduct);
  }

  // Add to cart
  fetch(window.routes.cartAddUrl, {
    body: JSON.stringify({
      items: productsForCart
    }),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(function () {

  });
}

/**
 * This function is used when GWP has infinite options
 */
const addBuyXGetYWithVariants = function() {
  let $modal = document.querySelector('#gwp-picker-modal'),
      $infiniteOptions = $modal.querySelector('.infinite-options'),
      $infiniteOptionsValues = $modal.querySelector('input[name=infinite_options_ids]'),
      $infiniteOptionsTitles = $modal.querySelector('input[name="properties[Selected samples]"]'),
      selectedVariants = $infiniteOptions.querySelectorAll('input[type=checkbox]:checked'),
      infiniteOptions = [],
      infiniteOptionsProductsAdded = sessionStorage.getItem('infiniteOptionsProductsAdded') ? JSON.parse(sessionStorage.getItem('infiniteOptionsProductsAdded')) : [],
      items = [],
      parentItem = {
        id: window.buyXgetY.yID,
        quantity: 1,
        properties: {
          "Selected samples": parseInt($infiniteOptionsTitles.value),
          _io_order_group: window.buyXgetY.yID,
          type: ''
        }
      };

  if (!$infiniteOptionsValues) {
    return;
  }

  if (selectedVariants.length < window.yInfiniteOptions.minSelections && window.yInfiniteOptions.isRequired) {
    $infiniteOptions.classList.add('warning');
    alert('Please select your options before adding this item to cart.');
    return;
  }

  if (isYInCart()) {
    alert(window.buyXgetY.yAlreadyInCartMessage);
    return;
  }

  infiniteOptionsProductsAdded.push(parentItem.id);
  items.push(parentItem);

  infiniteOptions = $infiniteOptionsValues.value.split(',');
  infiniteOptions.forEach(function(option) {
    items.push({
      id: parseInt(option),
      quantity: 1,
      properties: {
        _io_parent_order_group: parentItem.id
      }
    });
  })

  $.post(window.routes.cartAddUrl + '.js',{
    formType: "product",
    utf8: "✓",
    items: items
  }, function (result, status) {
    if (status === "success") {
      // Set infinite options product to prevent adding in cart in other tabs
      sessionStorage.setItem('infiniteOptionsProductsAdded', JSON.stringify(infiniteOptionsProductsAdded));

      window.buyXgetY.inCart = true;

      var clickedElement = $modal.querySelector('.gwp-submit');
      clickedElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: items[0],
          quantity: 1
        }
      }));

      // Dirty hack to run function without event
      $modal.target = $modal;
      closePopup($modal);
    } else {
      console.log('error');
    }
  }, 'json');
}

const addBuyXGetYWithoutVariants = function() {
  let $modal = document.querySelector('#buyxgety-modal'),
      yProductAdded = sessionStorage.getItem('yProductAdded') ? sessionStorage.getItem('yProductAdded') : null,
      item = {
        id: window.buyXgetY.yID,
        quantity: 1
      };

  $.post(window.routes.cartAddUrl + '.js',{
    formType: "product",
    utf8: "✓",
    items: [item]
  }, function (result, status) {
    if (status === "success") {
      let clickedElement = $modal.querySelector('.gwp-submit');

      sessionStorage.setItem('yProductAdded', window.buyXgetY.yID);
      window.buyXgetY.inCart = true;
      clickedElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: item,
          quantity: 1
        }
      }));

      // Dirty hack to run function without event
      $modal.target = $modal;
      closePopup($modal);
    } else {
      console.log('error');
    }
  }, 'json');
}

const buyXGetYHasMinimumQuantity = function(cartItems) {
  let totalQuantityX = 0;

  // Calculate total quantity of xIDs in cart
  cartItems.forEach(function (item) {
    if (window.buyXgetY.xIDs.includes(item.id)) {
      totalQuantityX += item.quantity;
    }
  });

  if (totalQuantityX >= window.buyXgetY.conditionAmount && !includesObjectProperty(cartItems, 'id', window.buyXgetY.yID)) {
    return true;
  }

  return false;
}

const buyXGetYHasMinimumPrice = function(cartItems) {
  let totalPriceX = 0,
      priceRate = getPriceRate();

  cartItems.forEach(function (item) {
    if (window.buyXgetY.xIDs.includes(item.id)) {
      totalPriceX += item.price * item.quantity;
    }
  });

  totalPriceX *= priceRate;

  if (totalPriceX >= window.buyXgetY.conditionAmount && !includesObjectProperty(cartItems, 'id', window.buyXgetY.yID)) {
    return true;
  }

  return false;
}

const addBuyXGetY = function(items, isUpdate = false) {
  if (typeof window.buyXgetY !== 'undefined') {
    if (!isYInCart() && window.buyXgetY.isActive && window.buyXgetY.xIDs.includes(items[0].id) && window.buyXgetY.yID && window.buyXgetY.yAutomaticAddToCart) {
      if ((window.buyXgetY.condition === 'min_quantity' && buyXGetYHasMinimumQuantity(items)) ||
        (window.buyXgetY.condition === 'min_amount' && buyXGetYHasMinimumPrice(items))) {
        items.push({
          id: window.buyXgetY.yID,
          quantity: window.buyXgetY.yQuantity,
          price: window.buyXgetY.yPrice
        });
      }
    }

    if (isUpdate) {
      var formattedItems = {};
      items.forEach(function (item) {
        formattedItems[item.id] = item.quantity;
      });
      items = formattedItems;
    }
  }

  return items;
}

const addRelatedProductsFromTopItemInCart = function() {
  if ($('.Cart__ItemList .CartItem__Title.Heading a').length) {
    var handle = $('.Cart__ItemList .CartItem__Title.Heading a').first().data('product-handle')
    if (handle) {
      var url = '/products/' + handle + '?view=cart-related'
      $.ajax({
        url: url,
        success: function (response) {
          $('.Drawer__Products').html('').append(response)
        }
      })
    }
  }
}

const tapfiliateRef = function() {
  if (typeof Cookies !== 'undefined') {
    if (document.location.search.indexOf('ref=') > -1) {
      Cookies.set('tapfiliateRef', getUrlParameter('ref'))
    }
    if (Cookies.get('tapfiliateRef')) {
      $('.switch-site-container a').each(function () {
        var ref = Cookies.get('tapfiliateRef')
        var langLink = $(this).attr('href')
        if (!langLink) {
          return
        }
        if (langLink.indexOf('?') > 1) {
          langLink = langLink + '&ref=' + ref
        } else {
          langLink = langLink + '?ref=' + ref
        }
        $(this).attr('href', langLink)
      })
    }
  }
}

class Junip {
  constructor(storeKey) {
    this.storeKey = storeKey;
    this.apiUrl = 'https://api.juniphq.com';
    this.lastMethodCalled = null;
    this.lastMethodArgCalled = null;
    this.next = null;
    this.prev = null;
    this.pageAppend = '';
    this.activePage = 1;
    this.reviewsPerPage = 5;
    this.reviews = [];
    this.product = null;
    this.products = [];
    this.eventOnLoad = null;
    this.eventOnPageLoad = null;
    this.isBundle = false;
  }

  async sendRequest(url, method) {
    let _this = this;

    return new Promise(function(resolve, reject) {
      let xhr = new XMLHttpRequest();
      xhr.open(method, _this.apiUrl + url, true);
      xhr.setRequestHeader('Junip-Store-Key', _this.storeKey);

      xhr.onreadystatechange = function () {
        if (this.readyState === 4) {
          if (xhr.status >= 400) {
            reject({
              message: xhr.statusText,
              status: xhr.status
            });
          } else {
            const response = JSON.parse(xhr.response);
            if (response.meta) {
              _this.next = response.meta.page.after;
              _this.prev = response.meta.page.before;
            }
            resolve(response);
          }
        }
      };

      xhr.onerror = function () {
        reject({
          message: 'HttpRequest error',
          status: xhr.status
        });
      }

      xhr.send();
    }).catch(function(error) {
      console.log(error);
    });
  }

  async getNextPage() {
    if (this.next === null) {
      return;
    }

    this.pageAppend = `?page[after]=${this.next}`;

    if (this.lastMethodArgCalled) {
      return await this[this.lastMethodCalled](this.lastMethodArgCalled);
    } else {
      return await this[this.lastMethodCalled]();
    }
  }

  async getProducts(product_remote_ids) {
    let url = `/v1/products/${this.pageAppend}`;
    url += this.appendUrlOption(url, 'filter[remote_ids]', product_remote_ids);

    let response = await this.sendRequest(url, 'GET');

    this.lastMethodCalled = 'getProduct';
    this.lastMethodArgCalled = product_remote_ids;
    this.pageAppend = '';

    if (response && response.products) {
      return response.products;
    }

    return [];
  }

  async getProductReviews(product_remote_ids) {
    let url = `/v1/product_reviews/${this.pageAppend}`;
    url += this.appendUrlOption(url, 'filter[product_remote_ids]', product_remote_ids);
    url += this.appendUrlOption(url, 'sort[field]', 'rating');
    url += this.appendUrlOption(url, 'sort[order]', 'desc');
    url += this.appendUrlOption(url, 'include', 'attribute_records,customer,product');

    let response = await this.sendRequest(url, 'GET');

    this.lastMethodCalled = 'getProductReviews';
    this.lastMethodArgCalled = product_remote_ids;
    this.pageAppend = '';

    if (response && response.product_reviews) {
      return response.product_reviews;
    }

    return [];
  }

  async loadAllProductReviews(product_remote_ids) {
    let reviews;

    if (product_remote_ids.includes(',')) {
      this.isBundle = true;
    }

    if (this.reviews.length === 0) {
      reviews = [].concat(await this.getProductReviews(product_remote_ids) || []);
    } else {
      reviews = [].concat(await this.getNextPage() || []);
    }

    this.addReviews(reviews);

    if (reviews.length === 50) {
      return await this.loadAllProductReviews(product_remote_ids);
    }
  }

  async loadProduct(product_remote_ids) {
    let products = await this.getProducts(product_remote_ids);

    if (products.length) {
      this.product = products[0];
    }
  }

  async loadProducts(product_remote_ids) {
    let products = await this.getProducts(product_remote_ids);

    if (products.length) {
      this.products = products;
    }
  }

  appendUrlOption(url, option, value) {
    let appendCharacter = '?';

    if (url.includes('?')) {
      appendCharacter = '&';
    }

    return `${appendCharacter}${option}=${value}`;
  }

  addReviews(reviews) {
    this.reviews = reviews ? [...this.reviews, ...reviews] : this.reviews;
  }

  getReviews() {
    return this.reviews;
  }

  getActivePage() {
    return this.activePage;
  }

  setReviewsPerPage(reviewsPerPage) {
    this.reviewsPerPage = reviewsPerPage;
  }

  printProductRating() {
    let $productRating = document.querySelector('.junip-main-product-rating');
    let ratingCount = this.isBundle ? this.reviews.length : this.product.rating_count;

    if (ratingCount === 0) {
      return;
    }

    let html = `
      <a href="#" class="spr-badge" data-rating="${this.product.rating_average}">
        <span class="spr-starrating spr-badge-starrating" data-rating-round="${this.getRatingRound(this.product.rating_average)}">
      `;

    html += `</span>`;

    if (window.Junip.reviewCountEnabled) {
      html += `
        <span class="spr-badge-caption">${(ratingCount) ? ratingCount : 'No'} review${(ratingCount !== 1) ? 's' : ''}</span>
      `;
    }

    html += `</a>`;

    $productRating.innerHTML = html;
  }

  printProductsRating() {
    let $productsRating = document.querySelectorAll('.junip-product-rating');
    let _this = this;

    $productsRating.forEach(function($productRating) {
      const id = $productRating.dataset.productId;

      for (let i = 0; i < _this.products.length; i++) {
        if (id === _this.products[i].remote_id) {
          if (_this.products[i].rating_average) {
            let html = `
              <div class="spr-badge" data-rating="${_this.products[i].rating_average}">
                <span class="spr-starrating spr-badge-starrating" data-rating-round="${_this.getRatingRound(_this.products[i].rating_average)}">
              `;

            html += `</span>`;

            if (window.Junip.reviewCountEnabled) {
              html += `<span class="spr-badge-caption">(${_this.products[i].rating_count})</span>`;
            }

            html += `</div>`;

            $productRating.innerHTML = html;
          } else {
            $productRating.classList.add('hide');
          }
        }
      }
    });
  }

  printPage(page = 1) {
    let $reviews = document.querySelector('.junip-product-reviews');
    let $contentDiv = $reviews.querySelector('.reviews-content');
    let $paginationDiv = $reviews.querySelector('.reviews-pagination');
    let _this = this;
    const startIndex = (page - 1) *  parseInt(this.reviewsPerPage);
    const endIndex = startIndex + parseInt(this.reviewsPerPage);

    if (this.reviews.length === 0) {
      return;
    }

    let totalPages = Math.ceil(this.reviews.length / this.reviewsPerPage);
    this.activePage = page;

    $paginationDiv.innerHTML = '';
    $paginationDiv.innerHTML = this.createPaginationHtml(totalPages, page);

    $contentDiv.classList.add('fade-out');
    setTimeout(function() {
      $contentDiv.innerHTML = '';
      for (let i = startIndex; i < endIndex; i++) {
        if (!_this.reviews[i]) {
          break;
        }
        let $reviewDiv = _this.createReviewDiv(_this.reviews[i]);
        $contentDiv.appendChild($reviewDiv);
      }
      $contentDiv.classList.remove('fade-out');
    }, 300);

    if (typeof window[this.eventOnPageLoad] !== "undefined") {
      let _this = this;
      setTimeout(function() {
        window[_this.eventOnPageLoad]();
      }, 500);
    }
  }

  reviewsScrollTo(e) {
    e.preventDefault();
    const $reviews = document.querySelector('.junip-product-reviews');
    const stickyHeaderHeight = document.querySelector('#ProductStickyHeader') ? document.querySelector('#ProductStickyHeader').offsetHeight : 0;
    const announcementBarHeight = document.querySelector('.AnnouncementBar') ? document.querySelector('.AnnouncementBar').offsetHeight : 0;
    const offsetTop = $reviews.getBoundingClientRect().top + window.scrollY - stickyHeaderHeight - announcementBarHeight;

    window.scrollTo({
      top: offsetTop,
      behavior: "smooth"
    });
  }

  printNextPage() {
    let page = parseInt(this.activePage) + 1;
    const reviewsLength = this.reviews.length;

    if (page > (reviewsLength / this.reviewsPerPage) + 1) {
      return;
    }

    this.printPage(page);
    this.activePage = page;
  }

  printPreviousPage() {
    let page = parseInt(this.activePage) - 1;
    const reviewsLength = this.reviews.length;

    if (page > reviewsLength / this.reviewsPerPage || page < 1) {
      return;
    }

    this.printPage(page);
    this.activePage = page;
  }

  createBaseHtml() {
    let html = '';
    let $reviewsCount = document.querySelectorAll('[data-junip-reviews-count]');
    let $leaveReview = document.querySelectorAll('[data-junip-leave-review]');
    let ratingAverage = this.product.rating_average ? this.product.rating_average.toFixed(2) : 0;
    let ratingCount = this.isBundle ? this.reviews.length : this.product.rating_count;

    if (!this.product) {
      throw new Error('Error: this.product not found');
    }

    let reviewsCountHtml = `
      <h2 class="u-h2">${(ratingCount) ? ratingCount : 'No'} review${(ratingCount !== 1) ? 's' : ''}</h2>
      <div class="review-rating">
        <span class="spr-badge-starrating spr-starratings spr-review-header-starratings" data-rating-round="${this.getRatingRound(this.product.rating_average)}" aria-label="${this.product.rating_average} of 5 stars" role="img">
      `;

    reviewsCountHtml += `
        </span>
        <span>(${ratingAverage})</span>
      </div>`;

    if ($reviewsCount.length) {
      [].forEach.call($reviewsCount, function($reviewsCountItem) {
        $reviewsCountItem.innerHTML = reviewsCountHtml;
      });
    }
    else {
      html += reviewsCountHtml;
    }

    if (this.reviews.length) {
      html += `
          <div class="reviews-content"></div>
          <div class="reviews-pagination"></div>
        `;
    }

    if ($leaveReview.length) {
      [].forEach.call($leaveReview, function($leaveReviewItem) {
        $leaveReviewItem.innerHTML = `<button id="leave-review" type="button" class="Button Button--primary" area-label="Write a reivew">Write a review</button>`;
      });
    }
    else {
      html += `
          <button id="leave-review" type="button" class="Button Button--primary" area-label="Write a reivew">Write a review</button>
        `;
    }

    return html;
  }

  createReviewDiv(review) {
    let parser = new DOMParser();
    let createdAt = new Date(review.created_at);
    let html = `
<div class="review">`;

    if (this.isBundle) {
      html += `
      <div class="review-title">
        <h5 class="bold">${(review.product.title)}</h5>
      </div>`;
    }

    html += `
    <div class="review-rating">
      <span class="spr-badge-starrating spr-starratings spr-review-header-starratings" data-rating-round="${this.getRatingRound(review.rating)}" aria-label="${review.rating} of 5 stars" role="img"></span>
    </div>
    <div class="review-header">
      <div class="review-header-left">
        <div class="row bold"><span class="bold">${(review.customer.first_name) ? review.customer.first_name : ''}${(review.customer.last_name) ? ' ' + review.customer.last_name : ''}</span></div>
        <div class="row"><span>${(review.verified_buyer) ? 'Verified buyer' : '' }</span></div>
        <div class="row"><span>${createdAt.toLocaleString('en-us', { month: 'short' })} ${createdAt.getDate()}, ${createdAt.getFullYear()}</span></div>
      </div>
      <div class="review-header-right">`;

    if (review.attribute_records.length > 0) {
      review.attribute_records.forEach(function(attr) {
        html += `<div class="row"><span>${attr.name}:</span> <span class="bold">${attr.value}</span></div>`;
      });
    }

    html += `
      </div>
    </div>
    <div class="review-content">
      <h3 class="review-content-title">${review.title}</h3>
      <p class="review-content-body">
        ${review.body}
      </p>
      ${(review.would_recommend) ? '<div class="recommends">Recommends this product</div>' : '' }
    </div>`;

    if (review.response) {
      html += `
      <div class="review response">
        <div class="review-content">
          <h3 class="review-content-title">Nuori</h3>
          <p class="review-content-body">${review.response}</p>
        </div>
      </div>`;
    }

    html += `</div>`;
    let div = parser.parseFromString(html, 'text/html');

    return div.querySelector('.review');
  }

  createPaginationHtml(totalPages, activePage) {
    let html = `
        <ul>
          <li${(activePage === 1) ? ' class="disabled"' : ''} data-reviews-pagination-prev aria-label="Move to previous page" aria-disabled="true">Prev</li>`;

    for (let i = 1; i <= totalPages; i++) {
      if (totalPages > 9 && i !== 1 && i !== totalPages) {
        if (i === Math.ceil(((activePage - 3) / 2)) || i === Math.ceil(((activePage + 3 + totalPages) / 2))) {
          html += `<li${(i === activePage) ? ' class="active"' : ''} data-reviews-pagination-page="${i}" aria-label="Move to page ${i}">...</li>`;
          continue;
        }
        else if ((i < activePage - 3) || (i > activePage + 3)) {
          continue;
        }
      }
      html += `<li${(i === activePage) ? ' class="active"' : ''} data-reviews-pagination-page="${i}" aria-label="Move to page ${i}">${(i < 10) ? '0' + i : i}</li>`;
    }

    html += `
          <li${(activePage === totalPages) ? ' class="disabled"' : ''} data-reviews-pagination-next aria-label="Move to next page" aria-disabled="true">Next</li>
        </ul>
      `;

    return html;
  }

  getRatingRound(rating) {
    let iconClass;

    if (rating >= 4.75) {
      iconClass = "5";
    } else if (rating >= 4.50) {
      iconClass = "4_75";
    } else if (rating >= 4.25) {
      iconClass = "4_50";
    } else if (rating >= 4) {
      iconClass = "4_25";
    } else if (rating >= 3.75) {
      iconClass = "4";
    } else if (rating >= 3.50) {
      iconClass = "3_75";
    } else if (rating >= 3.25) {
      iconClass = "3_50";
    } else if (rating >= 3) {
      iconClass = "3_25";
    } else if (rating >= 2.75) {
      iconClass = "3";
    } else if (rating >= 2.50) {
      iconClass = "2_75";
    } else if (rating >= 2.25) {
      iconClass = "2_50";
    } else if (rating >= 2) {
      iconClass = "2_25";
    } else if (rating >= 1.75) {
      iconClass = "2";
    } else if (rating >= 1.50) {
      iconClass = "1_75";
    } else if (rating >= 1.25) {
      iconClass = "1_50";
    } else if (rating >= 1) {
      iconClass = "1_25";
    } else if (rating >= .75) {
      iconClass = "1";
    } else if (rating >= .50) {
      iconClass = "0_75";
    } else if (rating >= .25) {
      iconClass = "0_50";
    } else if (rating >= 0) {
      iconClass = "0_25";
    } else {
      iconClass = "0";
    }

    return iconClass;
  }

  loadCallbacks($element) {
    this.eventOnLoad = $element.dataset.reviewsOnload;
    this.eventOnPageLoad = $element.dataset.reviewsOnpageload;
  }

  onLoad(functionOnLoad) {
    if (typeof window[functionOnLoad] !== "undefined") {
      setTimeout(function() {
        window[functionOnLoad]();
      }, 2000);
    }
  }

  addEventListeners() {
    let $pagination = document.querySelector('.junip-product-reviews .reviews-pagination');
    let $leaveReview = document.querySelector('#leave-review');
    let $rating = document.querySelector('.junip-main-product-rating');
    let _this = this;

    if ($pagination) {
      $pagination.addEventListener('click', function(e) {
        let $target = e.target;

        if ($target.classList.contains('disabled') || $target.classList.contains('active')) {
          return;
        }

        if ($target.hasAttribute('data-reviews-pagination-page')) {
          const page = parseInt($target.getAttribute('data-reviews-pagination-page'));
          _this.printPage(page);
        } else if ($target.hasAttribute('data-reviews-pagination-prev')) {
          _this.printPreviousPage();
        } else if ($target.hasAttribute('data-reviews-pagination-next')) {
          _this.printNextPage();
        }
      });
    }

    if ($leaveReview) {
      $leaveReview.addEventListener('click', function() {
        let url = `https://forms.juniphq.com/review/onsite/product?store_key=${_this.storeKey}&product_id=${_this.product.id}`;
        window.open(url, '_blank');
      })
    }

    if ($rating) {
      $rating.addEventListener('click', _this.reviewsScrollTo);
    }
  }
}

const marqueeInit = function() {
  const marqueContainers = document.querySelectorAll('.marquee-container:not(.initialized)');

  marqueContainers.forEach(marqueContainer => {
    marquee(marqueContainer);
  });
}

const marquee = function(selector) {
  const parentSelector = selector,
        clone = parentSelector.innerHTML,
        firstElement = parentSelector.children[0],
        speed = selector.dataset.marqueeSpeed / 100;
  let i = 0;

  selector.classList.add('initialized');

  parentSelector.insertAdjacentHTML('beforeend', clone);
  parentSelector.insertAdjacentHTML('beforeend', clone);

  setInterval(function () {
    firstElement.style.marginLeft = `-${i}px`;
    if (i > firstElement.clientWidth) {
      i = 0;
    }
    i = i + speed;
  }, 20);
}

const videosLazyLoad = function() {
  const videos = document.querySelectorAll('video:not(.Video--lazyLoaded)');

  videos.forEach(video => {
    const lazyVideoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if ((video.closest('.Product__Slideshow') && entry.intersectionRatio === 1) || !video.closest('.Product__Slideshow')) {
            for (let source in entry.target.children) {
              const videoSource = entry.target.children[source];

              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                if (videoSource.src) {
                  video.src = videoSource.src;
                } else if (videoSource.dataset.src) {
                  video.src = videoSource.dataset.src;
                }
              }
            }

            const videoWrapper = video.parentElement;

            if (videoWrapper.classList.contains('loading')) {
              videoWrapper.classList.remove('loading');
              videoWrapper.classList.add('loaded');
            }

            video.play().catch(error => {
              console.error("Video playback failed:", error);
            });
            video.classList.remove("Video--lazyLoad");
            video.classList.add('Video--lazyLoaded');
            lazyVideoObserver.unobserve(video);
          }
        }
      })
    }, {
      threshold: .1
    });

    lazyVideoObserver.observe(video);
  });
}

const imagesLazyLoad = function() {
  const lazyLoadImages = document.querySelectorAll('img:not([width]), img:not([height])');

  lazyLoadImages.forEach(function(image) {
    image.addEventListener('load', function() {
      image.setAttribute('width', image.width);
      image.setAttribute('height', image.height);
    });

    // Trigger the lazy loading by setting the "src" attribute
    const src = image.getAttribute('data-bgset');
    if (src) image.src = src;
  });
}

const flattenHeights = function($element, force = false, $parent = null) {
  let $section = $parent ? $parent : $element.closest('.SectionPage__content')?.parentElement;

  if ($section.clientHeight === $element.clientHeight && !force) {
    return;
  }

  $section.style.minHeight = `${$element.clientHeight - 1}px`;
  $element.classList.add('loaded');

  if ($section.classList.contains('SectionPage--absoluteLeft')) {
    $section.style.paddingLeft = `40%`;
  }
}

const flickityInit = function() {
  const sliders = document.querySelectorAll('[data-flickity-config]:not(.flickity-enabled)');

  sliders.forEach(slider => {
    const flickity = new Flickity(slider, JSON.parse(slider.dataset.flickityConfig));
  });
}

const showKlaviyoBackInStockPopup = function(e) {
  e.preventDefault();
  const modal = document.querySelector('#back-in-stock-modal');
  const title = e.target.dataset.productTitle;
  const id = e.target.dataset.variantId;
  const formMessage = modal.querySelector('.FormMessage');

  if (formMessage) {
    const email = modal.querySelector('.Form__Input');
    email.value = "";
    formMessage.remove();
  }

  if (title === "" || id === "") {
    return;
  }

  modal.querySelector('.Heading').textContent = title;
  modal.querySelector('.Button').dataset.variantId = id;
  showPopup('#back-in-stock-modal');
}

const isValidEmail = function(email) {
  return !!String(email)
      .toLowerCase()
      .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
}

const initKlaviyoBackInStock = function() {
  buttonStateInterval = setInterval(klaviyoCheckButtonState, 100);
}

const klaviyoCheckButtonState = function() {
  const modal = document.querySelector('#back-in-stock-modal');
  const email = modal.querySelector('.Form__Input').value;
  const submitButton = modal.querySelector('.Button--primary');

  if (isValidEmail(email)) {
    submitButton.removeAttribute('disabled');
  } else {
    submitButton.setAttribute('disabled', 'disabled');
  }
}

const submitKlaviyoBackInStock = async function() {
  const PUBLIC_API_KEY = window.klaviyoApiKey;
  const modal = document.querySelector('#back-in-stock-modal');
  const variantId = modal.querySelector('.Button--primary').dataset.variantId;
  const email = modal.querySelector('.Form__Input').value;

  if (!PUBLIC_API_KEY) {
    return;
  }

  if (!isValidEmail(email)) {
    console.log('email is not valid');
    return;
  }

  const options = {
    method: 'POST',
    headers: {
      revision: '2024-02-15',
      'content-type':
          'application/json'
    },
    body: JSON.stringify({
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email
              }
            }
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            }
          }
        }
      }
    })
  };

  const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${PUBLIC_API_KEY}`;
  const response = await fetch(url, options);
  const formWrapper = modal.querySelector('.popup-body');
  const formMessage = document.createElement('div');
  const formTitle = document.createElement('h2');
  const formDescription = document.createElement('div');

  const successTitle = `You will be notified when the product is back in stock`;

  formWrapper.style.height = formWrapper.offsetHeight + 'px';
  formWrapper.classList.add('relative');
  formWrapper.classList.add('show');

  formMessage.className = 'FormMessage show';
  formTitle.className = "SectionHeader__Heading Heading u-h1";

  if (response.status === 202 || response.status === 200) {
    formMessage.classList.add('FormMessage--success');

    if (successTitle){
      formTitle.innerHTML = successTitle;
    }

    formMessage.appendChild(formTitle);
    formMessage.appendChild(formDescription);
  } else {
    const data = await response.json();

    if (data.errors.length === 0) {
      return;
    }

    formMessage.classList.add('FormMessage--fail');
    formTitle.innerHTML = `Error`;
    formDescription.innerHTML = data.errors[0].detail;
    // formDescription.innerHTML = response.errors[0].detail;

    const tryAgainButton = document.createElement('button');
    tryAgainButton.className = 'Button Button--primary close-alert';
    tryAgainButton.innerHTML = 'Try again';
    tryAgainButton.addEventListener('click', function () {
      formWrapper.classList.remove('hide-overflow');
      formMessage.remove();
    });

    formMessage.appendChild(formTitle);
    formMessage.appendChild(formDescription);
    formMessage.appendChild(tryAgainButton);
  }

  formWrapper.classList.add('hide-overflow');
  formWrapper.appendChild(formMessage);
}

const addAdaLabels = function() {
  const captcha = document.querySelector('.h-captcha textarea');

  if (captcha) captcha.setAttribute('aria-label', 'Captcha validation');
}

document.addEventListener('product:added', function(event) {
  let handle = null
  if ($('[data-product-json]').length) {
    const productObject = JSON.parse($('[data-product-json]').html())
    handle = productObject.product.handle
  } else if ($('[data-variant-id]').length) {
    handle = $('[data-variant-id="' + event.detail.variant + '"]').data('product-handle')
  } else {
    handle = event.detail.handle;
  }

  const url = '/products/' + handle + '?view=cart-related'
  $.ajax({
    url: url,
    success: function(response) {
      $('.Drawer__Products').html('').append(response)
    }
  })
});

$(document).ready(async function () {
  // Load events
  $(document).on('click', '[data-popup-target]', showPopup);
  $(document).on('click', '[data-toggle-target]', toggleContent);
  $(document).on('click', '.popup-modal', closePopup);
  $(document).on('click', '[data-action="close-popup"]', hidePopup);
  $(document).on('click', '[data-action="close-announcement-bar"]', hideAnnouncementBar);
  $(document).on('click', '#gwp-picker-modal .gwp-submit', addBuyXGetYWithVariants);
  $(document).on('click', '#buyxgety-modal .gwp-submit', addBuyXGetYWithoutVariants);
  $(document).on('click', '[data-back-in-stock]', showKlaviyoBackInStockPopup);
  $(document).on('click', '#back-in-stock-modal .Button--primary', submitKlaviyoBackInStock);
  $(document).on('submit', 'form[action="/cart"]', checkCartMinimum);
  $(document).on('change', '#infiniteoptions-container .infinite-options label', infiniteOptionUpdateProduct);
  $(document).on('change', '#gwp-picker-modal .infinite-options label', infiniteOptionUpdateGWP);
  $(document).on('click', '.kvalifik-ajax', handleAjaxCart);
  $(window).on('resize', alignProductTitles);

  if (window.stickyAnnouncementScrollOffset || window.stickyHeaderScrollOffset) {
    $(document).on('scroll', stickyBarScroll);
  }

  if (document.getElementById('ProductStickyHeader')) {
    $(document).on('scroll', stickyProductHeaderScroll);
  }

  if (document.querySelector('.Cart__ShippingNotice') && document.querySelector('.Cart__FreeSamplesNotice')) {
    $(document).on('click', '.Cart__FreeSamplesNotice a', freeSampleNoticeScroll);
    $(window).on('resize', setFreeSamplesNoticeOffsetTop);
    setFreeSamplesNoticeOffsetTop();
  }

  addRelatedProductsFromTopItemInCart();
  tapfiliateRef();
  initRegularPopup();
  alignProductTitles();
  imagesLazyLoad();
  videosLazyLoad();
  marqueeInit();
  flickityInit();
  initKlaviyoBackInStock()
  await loadJunipReviews();

  setTimeout(addAdaLabels, 1000);
});